module.exports = __webpack_public_path__ + "img/product_7.ead6f29.jpg";